import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, from, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { ContextoService } from './contexto.service';
import { PermisosService } from './permisos.service';

@Injectable({
  providedIn: 'root'
})
export class GestorSesionUsuarioService {

  constructor(
    private readonly msalService: MsalService,
    private readonly contextoService: ContextoService,
    private readonly permisosService: PermisosService
  ) { }

  public cargarPermisosUsuario(): Observable<boolean> {
    const accounts = this.msalService.instance.getAllAccounts();
    const account = accounts[0];

    if (!account) {
      return of(false);
    }

    return from(this.msalService.instance.acquireTokenSilent({
      scopes: ['openid', 'profile'],
      account: account
    })).pipe(
      switchMap(response => {
        if (response.account) {
          this.msalService.instance.setActiveAccount(response.account);
        }
        return this.procesarTokenYCargarPermisos();
      }),
      catchError(() => of(false))
    );
  }

  public limpiarSesion(): void {
    this.contextoService.limpiarContexto();
  }

  private procesarTokenYCargarPermisos(): Observable<boolean> {
    const contextoExistente = this.contextoService.obtenerContextoActivo();
    if (contextoExistente?.modo) {
      return of(true);
    }

    const organizaciones = this.contextoService.obtenerOrganizacionesJWT();
    const orgRoles = this.contextoService.obtenerOrgRolesJWT();

    if (organizaciones.length === 0) {
      return of(false);
    }

    const primeraOrg = organizaciones[0];
    
    const rolesParaOrg = orgRoles
      .filter(or => or.orgId === primeraOrg.orgId)
      .map(or => or.role);

    if (rolesParaOrg.length === 0) {
      return of(false);
    }

    this.contextoService.seleccionarContexto(
      primeraOrg.orgId, 
      primeraOrg.razonSocial, 
      rolesParaOrg, 
      []
    );
    
    const rolPrincipal = rolesParaOrg[0];
    return this.permisosService.cargarPermisosParaContexto(primeraOrg.orgId, rolPrincipal).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
